import _ from 'lodash'
import { nanoid } from 'nanoid'

export const createId = (prefix: string) => {
  return `${prefix}#${nanoid()}`
}

export const getStripeKey = (): string => {
  const stripeKey = process.env.STRIPE_KEY
  if (!stripeKey) {
    throw new Error('Missing STRIPE_KEY')
  }
  return stripeKey
}

export const getContractorBucketName = (): string => {
  const bucketName = process.env.CONTRACTOR_S3_BUCKET
  if (!bucketName) {
    throw new Error('Missing CONTRACTOR_S3_BUCKET')
  }
  return bucketName
}

export const splitCompositeKey = (key: string, divider: string = '#-#') => {
  return _.keyBy(key.split(divider), (value) => {
    return value.split('#')[0]
  })
}
